import { linkTitlePlugin } from './plugin'

export { LINK_TITLE_LOADING_EVENT } from './config'

export const initLinkTitlePlugin = () => {
  if (CKEDITOR.plugins.get('linktitle')) {
    return
  }

  CKEDITOR.plugins.add('linktitle', linkTitlePlugin)
}
